import React from 'react';
import { Link } from 'react-router-dom';
import { resolveApiAssetUrl } from '../lib/api';
import { providersFromResponse } from '../lib/providerLogos';
import { SECTIONS, sectionHook } from '../lib/domHooks';

export { providersFromResponse } from '../lib/providerLogos';

/**
 * `/game-providers` yanıtını ana sayfa şeritlerinin kullandığı ortak biçime
 * çevirir. Yeni uçtaki `providers` ad + logo taşır; `items` yalnızca eski
 * sürümlerle uyum için bırakılan slug listesidir.
 */
/** Merit, Paris ve Zümrüt ana sayfalarının ortak sağlayıcı logo şeridi. */
const ProviderStrip = ({ providers = [], classPrefix }) => {
  if (!providers.length) return null;

  return (
    <section {...sectionHook(SECTIONS.PROVIDERS)}>
      <div className={`${classPrefix}-section-head`}>
        <h2 className={`${classPrefix}-section-title`}>Popüler Sağlayıcılar</h2>
      </div>
      <div className={`${classPrefix}-providers`}>
        {providers.map((provider) => (
          <Link
            key={provider.slug}
            to={`/slotlar?provider=${encodeURIComponent(provider.slug)}`}
            className={`${classPrefix}-provider`}
            title={provider.name}
          >
            {provider.logo ? (
              <img
                src={resolveApiAssetUrl(provider.logo)}
                alt={provider.name}
                className="max-h-8 max-w-full w-auto object-contain"
                loading="lazy"
              />
            ) : provider.name}
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ProviderStrip;
